/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 트리 데이터스토어 클래스를 정의한다.
 *
 * @file /src/models/store/tree/Tree.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 5. 14.
 */
import * as parent from '@models/store/Store';
import { Provider } from '@models/store/Provider';
import { Record } from '@models/store/Record';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T, P extends Provider> extends parent.Properties<T, P> {
    /**
     * 이벤트리스너
     */
    listeners?: Listeners<T>;
}

export class Tree<P extends Provider> extends parent.Store<P, number[]> {
    /**
     * 스토어타입
     */
    type = 'tree' as 'tree';

    /**
     * 트리 데이터스토어 클래스를 정의한다.
     *
     * @param properties - 초기속성
     */
    constructor(public properties: Properties<Tree<P>, P> = null) {
        super(properties);
    }

    /**
     * 특정인덱스의 레코드를 가져온다.
     *
     * @param index - 인덱스
     * @returns 레코드
     */
    async getAt(index: number[]): Promise<Record | null> {
        if (index.length == 0) {
            return null;
        }

        const tree = [...index];
        let record = this.records.get(this.recordIds[tree.shift()]);
        /*
        while (tree.length > 0) {
            record = await record.getChildAt(tree.shift());
            if (record === null) {
                return null;
            }
        }
        */

        return record;
    }
}
